import { keysWithMap, nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var SignupType = t.keyof({
  openSignup: null,
  inviteOnly: null,
  requestAccess: null
});
export var Modes = keysWithMap({
  lens: 'lens',
  superAdmin: 'superAdmin',
  "public": 'public'
});
export var AppConfig = t.type({
  programName: nullable(t.string),
  signupType: SignupType,
  modes: t.array(Modes),
  hubLogoImageURL: nullable(t.string),
  signInWelcomeText: nullable(t.string),
  baseImageURL: t.string
});